import { DEFAULT_CONFIG } from '../constants';

export async function compressImage(file, maxWidth = 800, maxHeight = 800, quality = 0.75) {
  return new Promise((resolve, reject) => {
    if (!file) {
      return reject(new Error('No file provided for compression'));
    }

    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };

    img.onload = () => {
      let { width, height } = img;

      // Maintain aspect ratio
      if (width > maxWidth || height > maxHeight) {
        const aspect = width / height;
        if (width > height) {
          width = maxWidth;
          height = Math.round(maxWidth / aspect);
        } else {
          height = maxHeight;
          width = Math.round(maxHeight * aspect);
        }
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            return reject(new Error('Canvas compression failed'));
          }
          resolve(new File([blob], file.name.replace(/\.[^/.]+$/, '.jpg'), { type: 'image/jpeg' }));
        },
        'image/jpeg',
        quality
      );
    };

    img.onerror = (err) => reject(new Error('Failed to load image for compression'));
    reader.onerror = (err) => reject(new Error('Failed to read image file'));
    reader.readAsDataURL(file);
  });
}

export async function uploadAvatarImage(file) {
  const compressed = await compressImage(file, 800, 800, 0.75);

  const formData = new FormData();
  formData.append('file', compressed);
  formData.append('upload_preset', 'vAssistant');
  formData.append('cloud_name', 'djx2edbwi');

  const res = await fetch(DEFAULT_CONFIG.cloudinaryUrl, {
    method: 'POST',
    body: formData,
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Cloudinary upload failed: ${errorText}`);
  }

  const data = await res.json();
  if (!data.secure_url) {
    throw new Error('Cloudinary response did not contain a secure_url');
  }

  return data.secure_url;
}
